import { ThumbnailMetrics } from 'Roblox';
import { WebGLJson } from 'THREE';
import { httpService } from 'core-utilities';

import {
  Thumbnail3DJsonSuccess,
  Thumbnail3DJsonFail,
  Thumbnail3DJsonResponse,
  Thumbnail3DJsonStats,
  Thumbnail3DJsonUrlResponse,
  DefaultMaxRetry,
  DefaultMaxRetryInterval
} from '../constants/thumbnail3dConstant';

import { getAvatarThumbnail3dJsonUrl } from '../constants/urlConstant';
import thumbnailRenderer from '../util/thumbnailRenderer';

const { loadObjAndMtl3D } = thumbnailRenderer;

const get3DJsonData = (
  jsonRes: Thumbnail3DJsonResponse,
  success: Thumbnail3DJsonSuccess,
  fail: Thumbnail3DJsonFail,
  stats: Thumbnail3DJsonStats
) => {
  const jsonUrlConfig = {
    url: jsonRes.data.Url
  };
  httpService
    .get(jsonUrlConfig)
    .then((jsonUrlRes: Thumbnail3DJsonUrlResponse) => {
      success(jsonUrlRes.data, stats);
    })
    .catch(() => {
      fail('3D Thumbnail failed to load');
    });
};

const get3DJson = (
  targetId: number,
  success: Thumbnail3DJsonSuccess,
  fail: Thumbnail3DJsonFail,
  retries: number,
  retryInterval: number,
  stats: Thumbnail3DJsonStats
) => {
  const urlConfig = { url: getAvatarThumbnail3dJsonUrl(targetId), withCredentials: true };
  httpService
    .get(urlConfig)
    .then((jsonRes: Thumbnail3DJsonResponse) => {
      if (jsonRes.data && jsonRes.data.Final) {
        get3DJsonData(jsonRes, success, fail, stats);
      } else {
        stats.realRegeneration = false;
        if (retries-- > 0) {
          stats.retriesDone++;
          setTimeout(() => {
            get3DJson(targetId, success, fail, retries, retryInterval, stats);
          }, retryInterval);
        } else {
          fail('3D Thumbnail failed to load');
        }
      }
    })
    .catch(() => {
      fail('3D Thumbnail failed to load');
    });
};

const processRequest = (
  targetId: number,
  success: Thumbnail3DJsonSuccess,
  fail: Thumbnail3DJsonFail,
  retries: number,
  retryInterval: number
) => {
  const stats = {
    realRegeneration: false,
    startTime: new Date(),
    retriesDone: 0
  };
  get3DJson(targetId, success, fail, retries, retryInterval, stats);
};

const getThumbnailJson = (
  targetId: number,
  retries: number = DefaultMaxRetry,
  retryInterval: number = DefaultMaxRetryInterval
) => {
  if (!targetId) {
    return new Promise((resolve, reject) => {
      reject('TargetId can not be empty.');
    });
  }

  return new Promise((resolve, reject) => {
    processRequest(
      targetId,
      (json: WebGLJson, stats: Thumbnail3DJsonStats) => {
        const finishTime = new Date().getTime();
        const duration = finishTime - stats.startTime.getTime();
        if (ThumbnailMetrics) {
          ThumbnailMetrics.logFinalThumbnailTime(duration);
        }
        resolve({ json, performance: { duration } });
      },
      (error: string) => {
        if (ThumbnailMetrics) {
          ThumbnailMetrics.logThumbnailTimeout();
        }
        reject(error);
      },
      retries,
      retryInterval
    );
  });
};

export default {
  getThumbnailJson,
  loadObjAndMtl3D
};
